import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getAnalyticsCatalogRegistrationStatus } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { getUrlFromPathname } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import {
    AccountDetailsEventFlow,
    AnalyticsCatalogRegistrationStatus,
    TrackingEvents,
    TrackingPayload,
} from '@/utils/amplitude/analytics/core.types';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type TrackLeadingBidderModalViewedPayload = TrackingPayload & {
    approvalStatus: AnalyticsCatalogRegistrationStatus;
    eventFlow: AccountDetailsEventFlow;
};

export const trackLeadingBidderModalViewedAnalytics = (payload: TrackLeadingBidderModalViewedPayload) => {
    track(TrackingEvents.AuthModal.LeadingBidderModalViewed, payload);
};

export const useTrackLeadingBidderModalViewedAnalytics = (catalogId: number) => {
    const { pathname, search } = useLocation();
    const urlWithoutQuery = useAppSelector((state) => getUrlFromPathname(state, pathname));
    const url = search ? `${urlWithoutQuery}${search}` : urlWithoutQuery;
    const approvalStatus = useAppSelector((state) => getAnalyticsCatalogRegistrationStatus(state, catalogId));

    return useCallback(() => {
        trackLeadingBidderModalViewedAnalytics({
            approvalStatus,
            eventFlow: AccountDetailsEventFlow.Bidding,
            pageName: getAmplitudePageNameFromPath(pathname, search),
            url,
        });
    }, [approvalStatus, pathname, search, url]);
};
